<div
    [id]="widget().id"
    [attr.data-raw-id]="widget().id"
    [style.position]="'relative'"
    [style.width.%]="width()"
    [style.top.px]="positionY()"
    [style.left]="positionX()"
>
    <div
        class="widget click-outside-close-prevent"
        [class.active]="isWidgetSelected() && extendedWidgetParams()?.hasSetting"
        [class.active-more-action]="isShowMoreActionState()"
        cdkDrag
        [cdkDragData]="widget()"
        (cdkDragStarted)="dragStarted()"
        (cdkDragEnded)="dragEnded()"
        (mouseenter)="isHovered.set(true)"
        (mouseleave)="isHovered.set(false)"
    >
        <div class="info-label-container">
            @if (isHidden()) {
                <div class="info-label" [tooltip]="tooltip" [tooltipAppendToBody]="true">
                    <img [src]="hiddenIconPath()" [alt]="hiddenIconTooltip() | translate" />
                    <ng-template #tooltip>
                        {{ hiddenIconTooltip() | translate }}
                    </ng-template>
                </div>
            }
        </div>

        <div class="custom-dnd-preview" *cdkDragPreview>
            <img src="./assets/img/websites/lpc-widget-preview-icon.svg" alt="lpc-widget-preview-icon" />
        </div>
        <div class="widget-placeholder custom-dnd-placeholder" *cdkDragPlaceholder></div>
        <web-view-resolver [widget]="widget()" />

        @if (controlsVisible()) {
            <web-item-controls
                class="widget-controls"
                [widgetName]="widgetName()"
                [selectActionTooltip]="'control_widget_settings' | translate"
                [disableCopyEvent]="isCrmProductWidgetRestricted()"
                [disableRemoveEvent]="isCrmProductWidgetRestricted()"
                (copyEvent)="copyWidget()"
                (deleteEvent)="removeWidget()"
                (selectEvent)="selectWidget()"
                (toggleMoreActionState)="setMoreActionState($event)"
            />
            <web-drag-handle class="drag-handle" cdkDragHandle />
            @if (extendedWidgetParams()?.showControls) {
                <div
                    class="edit-widget-control"
                    [title]="'control_widget_settings' | translate"
                    (click)="selectWidget()"
                    [style.z-index]="editControlZIndex()"
                >
                    <span class="sp-icon icon-ap-edit"> </span>
                </div>
            }
            @if (!isCrmProductWidgetRestricted()) {
                <div class="add-widget-control" (click)="addWidget()">
                    <button class="add-widget-btn" [tooltip]="'control_add_widget' | translate">
                        <span class="sp-icon icon-plus-add"> </span>
                    </button>
                </div>
            }
        }

        @if (widgetErrors() && !isWidgetSelected()) {
            <span class="sp-icon icon-warning warning-element"></span>
        }
    </div>
</div>
